import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

import CommonTheme from '../../../Theme.js';
import * as validateRule from '../../validateRule.js';

/**
 * 共通部分スタイル定義。
 */
const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    flexDirection: 'column',
    marginTop: '60px',
    padding: '16px 2px',
  },
  box: {
    background: '#fff',
    boxShadow: '0 0 10px #333',
    maxWidth: theme.breakpoints.values.sm,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  title: {
    fontSize: '1.5em',
    margin: '0px 20px 16px 20px',
    textAlign: 'center',
    fontWeight: 'bold',
    color: CommonTheme.palette.primary.contrastText,
    backgroundColor: CommonTheme.palette.primary.main,
    padding: '10px 20px',
    position: 'relative',
  },
}));

/**
 * 子要素用共通スタイル定義。
 * @param {object} theme テーマ
 * @return {fuction}
 */
export const commonStyles = (theme) => ({
  button: {
    marginTop: '20px',
  },
  textField: {
    width: '70%',
  },
  typography: {
    textAlign: 'left',
    width: '70%',
    margin: 'auto',
  },
  noticeArea: {
    width: '90%',
    height: '250px',
    margin: '0 auto',
    marginBottom: 10,
    textAlign: 'left',
    fontSize: '1.016em',
    borderRadius: '3px',
    border: '3px solid #4F89C6',
    background: 'white',
    padding: '4px 10px',
    overflow: 'scroll',
    userSelect: 'auto',
  },
  noticeTitle: {
    margin: '0 auto',
    textAlign: 'center',
    fontSize: '1.4em',
    fontWeight: 'bold',
  },

});

/**
 * ログイン画面 テキストフィールドの描画。
 * @param {object} param0 描画オプション
 * @return {JSX.Element} テキストフィールド
 */
export const renderTextField = ({
  input,
  label,
  meta: {touched, error, valid},
  ...custom
}) => (
  <TextField
    variant="standard"
    label={label}
    helperText={touched && error}
    error={touched && !valid}
    InputProps={{
      min: 1,
    }}
    {...input}
    {...custom} />
);


/**
 * ログイン画面系列 必須チェックの手動実行
 *
 * ログイン画面系の画面で、バリデーションが動作しない場合があるため
 * 本メソッドで暫定的にチェックを行いチェックエラーとする。
 *
 * 項目に入力を行うとバリデーションが動作するようになるため、
 * 必須チェックのみ行う。
 *
 * @param {function} createCheckTargets 手動で未入力チェックを行う入力項目情報を生成するメソッド
 * @param {function} showMessage メッセージ表示関数
 * @return {boolean} チェック結果
 */
export const checkInputEmpty = (createCheckTargets, showMessage) => {
  const checkTargets = createCheckTargets();

  for (const checkTarget of checkTargets) {
    // 必須チェックエラーの場合はメッセージを表示
    if (validateRule.required(checkTarget.value)) {
      showMessage({
        message: {
          id: 'TKSCS00005E',
          values: [checkTarget.name, ''],
        },
      });

      return false;
    }
  }

  return true;
};

/**
 * ログイン画面 共通部分の描画。
 * @param {object} children 子要素
 * @return {JSX.Element} ログイン画面共通部分
 */
export default function Container({children}) {
  const classes = useStyles();

  return (
    <div>
      <form noValidate autoComplete="off" className={classes.root}>
        <div className={classes.box}>
          <div style={{height: '10px'}}></div>
          <Box className={classes.title} boxShadow={3}>
          定期調査システム
          </Box>
          {children}
          <div style={{height: '10px'}}></div>
        </div>
      </form>
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.object,
};
